const YANDEX_METRIKA_ID = 96194074;
const YANDEX_METRIKA_SRC = 'https://mc.yandex.ru/metrika/tag.js';

export const isYandexMetrikaDisabled = () => process.env.REACT_APP_DISABLE_YANDEX_METRIKA === 'true';

// Достижение цели Метрики. Безопасно вызывать до инициализации ym —
// вызов попадёт в очередь, созданную initYandexMetrika.
export const reachGoal = (goal, params) => {
	if (typeof window === 'undefined' || typeof window.ym !== 'function' || isYandexMetrikaDisabled()) {
		return;
	}

	window.ym(YANDEX_METRIKA_ID, 'reachGoal', goal, params);
};

export const ensureYandexMetrikaStub = () => {
	if (typeof window === 'undefined' || !isYandexMetrikaDisabled() || typeof window.ym === 'function') {
		return;
	}

	const yandexMetrikaStub = function () {};
	yandexMetrikaStub.__isYandexMetrikaStub = true;

	window.ym = yandexMetrikaStub;
};

export const initYandexMetrika = () => {
	if (typeof window === 'undefined' || typeof document === 'undefined' || isYandexMetrikaDisabled()) {
		return;
	}

	if (typeof window.ym !== 'function' || window.ym.__isYandexMetrikaStub) {
		window.ym = function () {
			(window.ym.a = window.ym.a || []).push(arguments);
		};
	}

	window.ym.l = Number(new Date());

	const existingScript = Array.from(document.scripts).find((script) => script.src === YANDEX_METRIKA_SRC);

	if (!existingScript) {
		const script = document.createElement('script');
		script.async = true;
		script.src = YANDEX_METRIKA_SRC;
		document.head.appendChild(script);
	}

	window.ym(YANDEX_METRIKA_ID, 'init', {
		clickmap: true,
		scrollMap: true,
		webvisor: true,
		trackLinks: true,
		accurateTrackBounce: true,
	});
};
